import { getUserTimezone } from '../utils/timezone';

export function getApiOptions(method: string, b: Record<string, unknown>, token?: string): RequestInit {
    // Use plain object instead of Headers() for better compatibility with Capacitor
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-User-Timezone': getUserTimezone(),
    };
    
    // Add Authorization header if token is provided
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    const body: BodyInit | null = !b || Object.keys(b).length === 0 ? null : JSON.stringify(b);

    // For Capacitor apps, don't use credentials: 'include' as it can cause CORS issues
    const isCapacitor = typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform();

    return {
        method,
        mode: 'cors',
        credentials: isCapacitor ? 'omit' : 'include',
        headers: headers,
        body
    };
}
